import { EMAIL_REGEX } from '@/components/Sender/utils/isAValidEmail';
import { PASSWORD_MIN_LENGTH } from './initialState';

const REQUIRED_FIELDS = [
  'fullName',
  'email',
  'emailConfirmation',
  'password',
  'passwordConfirmation',
];

export const getFieldErrors = (fields) => {
  const errors = {};
  const email = fields.email.trim();

  if (email && !EMAIL_REGEX.test(email)) errors.email = 'invalidEmail';
  if (fields.emailConfirmation && fields.emailConfirmation.trim() !== email) {
    errors.emailConfirmation = 'emailsDoNotMatch';
  }
  if (fields.password && !fields.password.trim()) {
    errors.password = 'passwordBlank';
  } else if (fields.password && fields.password.length < PASSWORD_MIN_LENGTH) {
    errors.password = 'passwordTooShort';
  }
  if (
    fields.passwordConfirmation &&
    fields.passwordConfirmation !== fields.password
  ) {
    errors.passwordConfirmation = 'passwordsDoNotMatch';
  }

  return errors;
};

// Mirrors the backend, which drops spaces before checking the email is unique.
export const normalizeEmail = (email) => email.replace(/\s/g, '');

export const getRejectedEmailError = (fields, rejectedEmails) =>
  rejectedEmails[normalizeEmail(fields.email)] || null;

// The backend requires a branch, so a company without branches can't submit.
export const isFormReady = (fields, { rejectedEmails = {} } = {}) =>
  REQUIRED_FIELDS.every((key) => fields[key].trim() !== '') &&
  fields.branchId !== null &&
  (!fields.canViewOtherBranches || fields.inquiryBranchIds.length > 0) &&
  !getRejectedEmailError(fields, rejectedEmails) &&
  Object.keys(getFieldErrors(fields)).length === 0;

export const buildCreateAgentPayload = (fields) => ({
  full_name: fields.fullName.trim(),
  email: fields.email.trim(),
  password: fields.password,
  branch_id: fields.branchId,
  team_ids: fields.teamIds,
  inquiries_branch_ids: fields.canViewOtherBranches
    ? fields.inquiryBranchIds
    : [],
  permission_group_ids: fields.permissionGroupIds,
});

const SERVER_ERROR_FIELDS = {
  full_name: 'fullName',
  email: 'email',
  password: 'password',
  branch_id: 'branchId',
  team_ids: 'teamIds',
  inquiries_branch_ids: 'inquiryBranchIds',
  permission_group_ids: 'permissionGroupIds',
  groups: 'permissionGroupIds',
};

// DRF nests list item errors by index ({ 0: ['...'] }), so dig for the first
// message whatever the shape.
const firstMessage = (value) => {
  if (typeof value === 'string') return value;
  const nested = Array.isArray(value) ? value : Object.values(value || {});
  return nested.map(firstMessage).find(Boolean) || null;
};

// Errors for fields the form doesn't show stay under their backend key, so
// the caller can still surface them.
export const parseServerErrors = (errors = {}) =>
  Object.entries(errors).reduce((parsed, [key, value]) => {
    const message = firstMessage(value);
    if (message) parsed[SERVER_ERROR_FIELDS[key] || key] = message;
    return parsed;
  }, {});
